import { createSelector } from '@ngrx/store';
import { TimeBasedWorkPropositionState } from '../reducers/time-based-work-proposition.reducer';

export const selectTimeBasedWorkPropositionState = (state: any) =>
  state.timeBasedWorkProposition;

export const selectTimeBasedWorkProposition = createSelector(
  selectTimeBasedWorkPropositionState,
  (state: TimeBasedWorkPropositionState) => state.timeBasedWorkProposition
);

export const selectTimeBasedWorkPropositionLoading = createSelector(
  selectTimeBasedWorkPropositionState,
  (state: TimeBasedWorkPropositionState) => {
    return state.loading;
  }
);

export const selectTimeBasedWorkPropositionError = createSelector(
  selectTimeBasedWorkPropositionState,
  (state) => state.error
);
